<template>
  <!-- <a-card :bordered="false"> -->
  <div>
    <div class="page_top">
      <div class="title_wrapper">
        <div class="dis_flex">
          <h1 class="title_from">学习管理</h1>
        </div>
        <a-button
          type="primary"
          class="el_button el-button--primary"
          style="width: 62px"
          @click="showAddModal()"
          v-hasPermi="['system:learning:add']"
        >
          新增
        </a-button>
      </div>

      <div class="search_wrapper">
        <a-form layout="inline">
          <a-form-item label="标题">
            <a-input v-model="queryParam.fileTitle" placeholder="标题" allow-clear />
          </a-form-item>
          <a-form-model-item label="学习类别" prop="fileCategory">
            <a-select style="width: 180px" placeholder="请选择" v-model="queryParam.fileCategory">
              <a-select-option v-for="d in fileCategoryOptions" :key="d.dictValue" :value="d.dictValue">{{
                d.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form>
        <a-radio-group>
          <a-button class="el_button el_button_b" style="width: 62px" type="default" @click="resetQuery">
            重置
          </a-button>
          <a-button class="mr20" type="primary" @click="getList"> 查询 </a-button>
        </a-radio-group>
      </div>
      <div>
        <a-table
          :loading="tableLoading"
          :columns="columns"
          :data-source="learningList"
          @change="handleChangeInTable"
          :pagination="pagination"
          :customRow="getLearningDetail"
          :rowKey="
            (record, index) => {
              return index
            }
          "
        >
          <template slot="fileType" slot-scope="fileType" @change="changePage">
            <p style="color: #a4db85" v-if="fileType === '1'">成功</p>
            <p style="color: #e4a051" v-if="fileType === '2'">经验</p>
          </template>
        </a-table>
      </div>
    </div>
    <!-- 增加修改 -->
    <a-modal
      :title="formTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button class="w120" key="submit" type="primary" :loading="loading" @click="submitForm('form')">
          保存
        </a-button>
      </template>

      <a-form-model ref="form" :model="dataInfo" :rules="rules">
        <a-form-model-item label="标题" prop="fileTitle">
          <a-input v-model="dataInfo.fileTitle" allowClear />
        </a-form-model-item>

        <a-form-model-item label="学习类别" prop="fileCategory">
          <a-select placeholder="请选择" v-model="dataInfo.fileCategory">
            <a-select-option v-for="d in fileCategoryOptions" :key="d.dictValue" :value="d.dictValue">{{
              d.dictLabel
            }}</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="类型" prop="fileType">
          <a-select placeholder="请选择" v-model="dataInfo.fileType">
            <a-select-option v-for="d in fileTypeOptions" :key="d.dictValue" :value="d.dictValue">{{
              d.dictLabel
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="作者" prop="courseAuthor">
          <a-input v-model="dataInfo.courseAuthor" placeholder="请输入课程作者" />
        </a-form-model-item>
        <a-form-model-item label="简介" prop="briefIntroduction">
          <a-textarea autosize v-model="dataInfo.briefIntroduction" placeholder="请输入简介" />
        </a-form-model-item>
        <a-form-model-item label="封面图" prop="coverPicture">
          <upload-cmp
            :img-url="coverPictureInfo&&coverPictureInfo.fileName ? coverPictureInfo.fileName :''"
            :oss-id="coverPictureInfo.ossId"
            type="image,video"
            @fileUrlFn="coverPictureFn"
          ></upload-cmp>
          <a-input v-show="1 === 2" v-model="dataInfo.coverPicture" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="文件" prop="fileUrl">
          <upload-cmp
            :img-url="fileInfo&&fileInfo.fileName ? fileInfo.fileName : ''"
            :oss-id="fileInfo.ossId"
            type="image,video"
            @fileUrlFn="fileUrlFn"
          ></upload-cmp>
          <a-input v-show="1 === 2" v-model="dataInfo.fileUrl" placeholder="请输入" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { learningList, getLearning, addLearning, updateLearning } from '@/api/system/learning'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'
import UploadCmp from '@/components/UploadCmp/index'

const columns = [
  {
    title: '标题',
    dataIndex: 'fileTitle',
    key: '1',
    scopedSlots: { customRender: 'fileTitle' }
  },
  {
    title: '简介',
    dataIndex: 'briefIntroduction',
    key: '2',
    scopedSlots: { customRender: 'briefIntroduction' }
  },
  {
    title: '类型',
    dataIndex: 'fileType',
    key: '3',
    ellipsis: true,
    scopedSlots: { customRender: 'fileType' }
  },
  {
    title: '作者',
    dataIndex: 'courseAuthor',
    key: '4',
    ellipsis: true,
    scopedSlots: { customRender: 'courseAuthor' }
  },
  {
    title: '创建人',
    dataIndex: 'createBy',
    key: '5',
    ellipsis: true,
    scopedSlots: { customRender: 'createBy' }
  }
]
export default {
  name: 'Learning',
  components: {
    UploadCmp
  },
  mixins: [tableMixin],
  data () {
    return {
      columns,
      tableLoading: false,
      learningList: [],
      ossUrl: process.env.VUE_APP_OSS_URL,
      list: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      imgLoading: false,
      imageUrl: '',
      tabPosition: 'left',
      fileCategoryOptions:  [{dictLabel:'全部',dictValue:''}],
      fileTypeOptions: [],
      publishStatusOptions: [],
      loading: false,
      curLiIdx: 0,
      // 状态数据字典
      statusOptions: [],
      fileInfo: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      coverPictureInfo: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      queryParam: {
        fileCategory: '', // 类别 字典表类型：announcement_category
        fileTitle: undefined, // 标题
        fileType: undefined, // 字典表类型：announcement_type
        publishStatus: undefined // 发布状态 字典表类型：publish_status
      },
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表单弹窗
      visible: false,
      confirmLoading: false,
      submitLoading: false,
      formTitle: '',
      dataInfo: {
        coverPicture: undefined,
        briefIntroduction: undefined,
        courseAuthor: undefined,
        fileCategory: undefined, // 类别 字典表类型：announcement_category
        fileTitle: undefined, // 标题
        fileType: undefined, // 类型 字典表类型：announcement_type
        fileUrl: undefined, // 文件URL
        fileUrlList: [
          {
            // 文件URLList
            createBy: undefined, //	创建者	string
            createTime: undefined, // 创建时间	string
            fileName: undefined, //	string
            fileSuffix: undefined, //	string
            originalName: undefined, //	string
            ossId: undefined, //	integer
            params: undefined, //	请求参数	object
            searchValue: undefined, //	搜索值	string
            service: undefined, //	string
            updateBy: undefined, //	更新者	string
            updateTime: undefined, //	更新时间	string
            url: undefined //
          }
        ],
        id: undefined // ID
      },
      rules: {
        fileTitle: [{ required: true, message: '学习信息标题不能为空', trigger: 'blur' }],
        briefIntroduction: [{ required: true, message: '学习简介不能为空', trigger: 'blur' }],
        courseAuthor: [{ required: true, message: '学习课程作者不能为空', trigger: 'blur' }],
        fileUrl: [{ required: true, message: '学习信息url不能为空', trigger: 'blur' }],
        coverPicture: [{ required: true, message: '学习封面url不能为空', trigger: 'blur' }],
        fileCategory: [{ required: true, message: '学习类别不能为空', trigger: 'change' }],
        fileType: [{ required: true, message: '类型不能为空', trigger: 'change' }]
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      }
    }
  },
  filters: {
    filterDict (val, opts) {
      if (!val) return
      for (const d of opts) {
        if (d.dictValue === val) {
          return d.dictLabel
        }
      }
    }
  },
  created () {
    // 公告类别
    this.getDicts('announcement_category').then((response) => {
      this.fileCategoryOptions = this.fileCategoryOptions.concat(response.data)
    })
    // 公告类型
    this.getDicts('announcement_type').then((response) => {
      this.fileTypeOptions = response.data
    })
    // 发布状态
    this.getDicts('publish_status').then((response) => {
      this.publishStatusOptions = response.data
    })
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    getClearList () {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        fileCategory: undefined, // 类别 字典表类型：announcement_category
        fileTitle: undefined, // 标题
        fileType: undefined, // 字典表类型：announcement_type
        publishStatus: undefined // 发布状态 字典表类型：publish_status
      }
    },
    /** 查询学习信息列表 */
    getList () {
      this.tableLoading = true
      this.queryParam.pageNum = this.pagination.current
      this.queryParam.pageSize = this.pagination.pageSize
      learningList(this.queryParam).then((res) => {
        if (res.code === 200) {
          console.log(res.data.records, 'data')
          this.pagination.total = res.data.total
          this.learningList = res.data.records
        }
        this.tableLoading = false
      })
    },
    // 分页、排序、筛选变化时触发
    handleChangeInTable (pagination, filters, sorter) {
      this.form.performanceStatisticsSort = 1
      this.pagination = pagination
      this.getList()
    },
    /** 搜索按钮操作 */
    /* handleQuery () {
      this.getList()
    }, */
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        fileCategory: undefined, // 类别 字典表类型：announcement_category
        fileTitle: undefined, // 标题
        fileType: undefined, // 字典表类型：announcement_type
        publishStatus: undefined // 发布状态 字典表类型：publish_status
      }
      this.getList()
    },
    // 表单重置
    reset () {
      this.dataInfo = {
        fileCategory: undefined, // 类别 字典表类型：announcement_category
        fileTitle: undefined, // 标题
        fileType: undefined, // 类型 字典表类型：announcement_type
        fileUrl: undefined, // 文件URL
        fileUrlList: [
          {
            createBy: '',
            createTime: '',
            fileName: '',
            fileSuffix: '',
            originalName: '',
            ossId: undefined,
            service: 'huawei',
            url: ''
          }
        ],
        id: undefined // ID
      }
      this.imageUrl = ''
      this.fileInfo = {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
    },
    /** 新增按钮操作 */
    showAddModal () {
      this.visible = true
      this.reset()
      this.formTitle = '添加学习信息'
    },

    /** 修改按钮操作 */
    handleUpdate (id) {
      this.reset()
      const learningId = id
      getLearning(learningId).then((response) => {
        this.dataInfo = response.data
        const fileObj = this.dataInfo.fileUrlList[0]
        console.log(fileObj)
        this.fileInfo = fileObj
        console.log(this.fileInfo)
        this.$forceUpdate()
        this.formTitle = '修改学习信息'
        this.visible = true
      })
    },
    handleOk (e) {
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.visible = false
      this.reset()
    },
    submitForm (formName) {
      this.confirmLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateLearning(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.visible = false
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addLearning(this.dataInfo)
              .then((response) => {
                console.log(response)
                this.$message.success('新增成功', 3)
                this.visible = false
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    fileUrlFn (file) {
      this.dataInfo.fileUrl = file.ossId + ''
      this.fileInfo = file
    },
    coverPictureFn (file) {
      this.dataInfo.coverPicture = file.ossId + ''
      this.coverPictureInfo = file
    },
    // 去学习详情页面
    getLearningDetail: function (record, index) {
      return {
        on: {
          click: () => {
            console.log(record)
            this.$router.push({
              path: '/learning/details',
              query: { id: record.id }
            })
          }
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
/* *{
    margin:0;
    padding:0;
    border:none;
} */
.padding-top {
  background: #fff;
  padding: 20px;
}
ul li {
  list-style: none;
}
.mr10 {
  margin-right: 10px;
  color: var(--ThemeColor);
}
.w120 {
  width: 120px;
  //  background-color:  var(--ThemeColor);
}
.mr20 {
  margin-left: 20px;
  background-color: var(--ThemeColor);
}

.page_top {
  background: #fff;
  padding: 20px;
}
.search_wrapper {
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
}
.title_wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  justify-content: space-between;
}
.title_from {
  font-size: @titleFontSize;
  color: @titleColor;
  font-weight: bolder;
}
.table-operations {
  display: flex;
  flex-flow: row-reverse;
}
.btn_add {
  color: #fff;
  height: 35px;
  line-height: 35px;
}
.wrapper_page {
  /*  width:100%; */
  height: 100%;
  /*  padding: 10px 0px; */
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
